import type { CSSProperties, ReactNode } from 'react';
import { IconPlayerPauseFilled, IconPlayerPlayFilled } from '@tabler/icons-react';
import { ModelViewerArIcon } from './ModelViewerArIcon';
import classes from './ViewerControlButton.module.css';

export type ViewerControlButtonProps = {
  accentColor: string;
  onClick: () => void;
  ariaLabel: string;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  type?: 'button' | 'submit';
};

export function ViewerControlButton({
  accentColor,
  onClick,
  ariaLabel,
  children,
  className,
  style,
  type = 'button',
}: ViewerControlButtonProps) {
  const mergedClassName = className ? `${classes.button} ${className}` : classes.button;

  return (
    <button
      type={type}
      className={mergedClassName}
      style={{ color: accentColor, ...style }}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}

export type ViewerPlayPauseButtonProps = {
  accentColor: string;
  isPlaying: boolean;
  onClick: () => void;
  className?: string;
  style?: CSSProperties;
  playLabel?: string;
  pauseLabel?: string;
};

export function ViewerPlayPauseButton({
  accentColor,
  isPlaying,
  onClick,
  className,
  style,
  playLabel = 'Play',
  pauseLabel = 'Pause',
}: ViewerPlayPauseButtonProps) {
  return (
    <ViewerControlButton
      accentColor={accentColor}
      onClick={onClick}
      ariaLabel={isPlaying ? pauseLabel : playLabel}
      className={className}
      style={style}
    >
      {isPlaying ? <IconPlayerPauseFilled size={20} /> : <IconPlayerPlayFilled size={20} />}
    </ViewerControlButton>
  );
}

export type ViewerArButtonProps = {
  accentColor: string;
  onClick: () => void;
  className?: string;
  style?: CSSProperties;
  ariaLabel?: string;
};

export function ViewerArButton({
  accentColor,
  onClick,
  className,
  style,
  ariaLabel = 'View in AR',
}: ViewerArButtonProps) {
  return (
    <ViewerControlButton
      accentColor={accentColor}
      onClick={onClick}
      ariaLabel={ariaLabel}
      className={className}
      style={style}
    >
      <ModelViewerArIcon />
    </ViewerControlButton>
  );
}
